import React from 'react';
import { placeholderFromString } from "../../helpers/images";
export default function CardPlaceholder({ name }) { return /*#__PURE__*/ React.createElement("div", { className: "card card--placeholder" }, /*#__PURE__*/ React.createElement("img", { className: "card__icon", alt: "Card Placeholder", src: name ? placeholderFromString(name) : undefined })); }
